import { parseISO, format } from "date-fns"

export const parseDate = (dateStr?: string | null): Date | null | undefined => {
  return typeof dateStr === "string" ? parseISO(dateStr) : dateStr
}

export const convertLocalTimeToUTCTime = (date: Date | string) => {
  date = new Date(date)
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
}

// TODO: Investigate app-wide usage of this function
// If we are displaying a date in the UI exactly as-is from the server then formatDateWithoutConversion should be used.
// Likely best for date entry into the app
export const formatDate = (
  date: Date | string | null | undefined,
  fmt: string,
  utc: boolean = false
): string => {
  if (!date) {
    return ""
  }

  try {
    return format(utc ? convertLocalTimeToUTCTime(date) : date, fmt)
  } catch (err: any) {
    console.error(`Error: ${err}`)
    return ""
  }
}

// EN-5077 (https://dobackflip.atlassian.net/browse/EN-5077)
// Best for read-only dates that are displayed exactly as-is from the server
export const formatDateWithoutConversion = (
  date: Date | string | null | undefined,
  fmt: string
): string => {
  if (!date) {
    return ""
  }

  try {
    const dateObj = typeof date === "string" ? parseISO(date) : date
    return format(dateObj, fmt)
  } catch (err: any) {
    console.error(`Error: ${err}`)
    return ""
  }
}
